import { fetchApi } from '@/config/axiosSetting';
import {
  GetInitialVisitAdjusterEntryTabsQueryParamsType,
  GetInitialVisitAdjusterEntryTabsQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialvisitAdjusterEntryTabs/getInitialvisitAdjusterEntryTabsQuery.type';

export const getInitialVisitAdjusterEntryTabsFunction = (
  params: GetInitialVisitAdjusterEntryTabsQueryParamsType,
): Promise<GetInitialVisitAdjusterEntryTabsQueryResponseType[]> => {
  return fetchApi.get(
    `/initial/reports/${params?.id}/images/adjuster/entry_tabs/`,
    {
      params: {
        id: params?.id,
      },
    },
  );
};
